"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var LogoSection = function () { return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 5, pb: 1, pl: 4 }, { children: (0, jsx_runtime_1.jsx)("img", { height: 32, src: "/hudled-logo-color.svg", alt: "Hudled's Logo" }) }))); };
exports.default = LogoSection;
